import React from "react";
import { Dialog, DialogTitle, DialogContent, DialogActions, Button, TextField, Box } from "@mui/material";
import { useForm } from "react-hook-form";

export default function AddBeneficiaryModal({ open, onClose, onAdd }) {
  const {
    register,
    handleSubmit,
    formState: { errors },
    reset,
  } = useForm({ mode: "onChange" });

  const onSubmit = (data) => {
    onAdd(data);
    reset();
    onClose();
  };

  return (
    <Dialog open={open} onClose={onClose} maxWidth="xs" fullWidth>
      <DialogTitle>Add Beneficiary</DialogTitle>
      <DialogContent>
        <Box component="form" onSubmit={handleSubmit(onSubmit)} sx={{ mt: 1 }}>
          <TextField
            label="Name"
            fullWidth
            margin="normal"
            {...register("name", { required: "Name is required" })}
            error={!!errors.name}
            helperText={errors.name?.message}
          />
          <TextField
            label="Account Number"
            fullWidth
            margin="normal"
            {...register("accountNumber", { required: "Account Number is required" })}
            error={!!errors.accountNumber}
            helperText={errors.accountNumber?.message}
          />
          <TextField label="Remarks" fullWidth margin="normal" {...register("remarks")} />
          <DialogActions sx={{ px: 0, pb: 0, pt: 2 }}>
            <Button onClick={onClose} color="secondary">
              Cancel
            </Button>
            <Button type="submit" variant="contained" color="primary">
              Add
            </Button>
          </DialogActions>
        </Box>
      </DialogContent>
    </Dialog>
  );
}
